module.exports = __webpack_public_path__ + "img/login.c3b7357b.png";